import { jsxs as C, jsx as l } from "react/jsx-runtime";
import { getIconStyles as i } from "../styles.js";
const r = (e) => /* @__PURE__ */ C(
  "svg",
  {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: i(e),
    children: [
      /* @__PURE__ */ C("g", { clipPath: "url(#clip0_10066_3445)", children: [
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.7305 17.271C12.7305 16.8568 13.0663 16.521 13.4805 16.521L23.228 16.521C23.6422 16.521 23.978 16.8568 23.978 17.271C23.978 17.6852 23.6422 18.021 23.228 18.021L13.4805 18.021C13.0663 18.021 12.7305 17.6852 12.7305 17.271Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.0341797 17.271C0.0341797 16.8568 0.369966 16.521 0.78418 16.521H7.05176C7.46597 16.521 7.80176 16.8568 7.80176 17.271C7.80176 17.6852 7.46597 18.021 7.05176 18.021H0.78418C0.369966 18.021 0.0341797 17.6852 0.0341797 17.271Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.47835 13.7506C10.2087 13.6053 10.9658 13.6799 11.6537 13.9648C12.3417 14.2498 12.9298 14.7324 13.3435 15.3516C13.7572 15.9707 13.978 16.6987 13.978 17.4434C13.978 18.4419 13.5813 19.3996 12.8752 20.1057C12.1691 20.8118 11.2115 21.2085 10.2129 21.2085C9.46822 21.2085 8.74027 20.9877 8.12109 20.574C7.50192 20.1602 7.01933 19.5722 6.73436 18.8842C6.44939 18.1962 6.37482 17.4392 6.5201 16.7088C6.66538 15.9785 7.02397 15.3076 7.55054 14.781C8.0771 14.2544 8.74798 13.8958 9.47835 13.7506ZM11.0797 15.3506C10.6658 15.1792 10.2104 15.1343 9.77099 15.2217C9.33159 15.3091 8.92798 15.5249 8.6112 15.8417C8.29441 16.1585 8.07868 16.5621 7.99128 17.0015C7.90388 17.4408 7.94874 17.8963 8.12018 18.3102C8.29162 18.7241 8.58195 19.0779 8.95445 19.3268C9.32695 19.5757 9.76489 19.7085 10.2129 19.7085C10.8136 19.7085 11.3898 19.4699 11.8146 19.0451C12.2394 18.6203 12.478 18.0441 12.478 17.4434C12.478 16.9954 12.3452 16.5574 12.0963 16.1849C11.8474 15.8124 11.4936 15.5221 11.0797 15.3506Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0.0341797 7.44336C0.0341797 7.02915 0.369966 6.69336 0.78418 6.69336H17.1978C17.612 6.69336 17.9478 7.02915 17.9478 7.44336C17.9478 7.85757 17.612 8.19336 17.1978 8.19336H0.78418C0.369966 8.19336 0.0341797 7.85757 0.0341797 7.44336Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ l(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M19.4783 3.75057C20.2087 3.60529 20.9658 3.67985 21.6537 3.96483C22.3417 4.2498 22.9298 4.73239 23.3435 5.35156C23.7572 5.97074 23.978 6.69869 23.978 7.44336C23.978 8.44194 23.5813 9.39962 22.8752 10.1057C22.1691 10.8118 21.2115 11.2085 20.2129 11.2085C19.4682 11.2085 18.7403 10.9877 18.1211 10.574C17.5019 10.1602 17.0193 9.57221 16.7344 8.88422C16.4494 8.19623 16.3748 7.43918 16.5201 6.70882C16.6654 5.97845 17.024 5.30757 17.5505 4.78101C18.0771 4.25444 18.748 3.89585 19.4783 3.75057ZM21.0797 5.35065C20.6658 5.1792 20.2104 5.13435 19.771 5.22175C19.3316 5.30915 18.928 5.52488 18.6112 5.84167C18.2944 6.15845 18.0787 6.56206 17.9913 7.00146C17.9039 7.44085 17.9487 7.89629 18.1202 8.31019C18.2916 8.72409 18.582 9.07786 18.9545 9.32675C19.327 9.57565 19.7649 9.7085 20.2129 9.7085C20.8136 9.7085 21.3898 9.46985 21.8146 9.04505C22.2394 8.62026 22.478 8.04411 22.478 7.44336C22.478 6.99536 22.3452 6.55742 22.0963 6.18492C21.8474 5.81242 21.4936 5.52209 21.0797 5.35065Z",
            fill: "currentColor"
          }
        )
      ] }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_10066_3445", children: /* @__PURE__ */ l(
        "rect",
        {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.012207 0.392456)"
        }
      ) }) })
    ]
  }
);
export {
  r as FiltersIcon
};
//# sourceMappingURL=FiltersIcon.js.map
